import { render, staticRenderFns } from "./DenouncePopup.vue?vue&type=template&id=2f2f108e&scoped=true&"
import script from "./DenouncePopup.vue?vue&type=script&lang=ts&"
export * from "./DenouncePopup.vue?vue&type=script&lang=ts&"
import style0 from "./DenouncePopup.vue?vue&type=style&index=0&id=2f2f108e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f108e",
  null
  
)

export default component.exports